<template>
  <div
    class="text-truncate"
    style="direction: ltr"
  >
    {{ data.value }}
  </div>
</template>

<script>
import BaseCellType from './Base.vue'

export default {
  name: 'DatetimeCellType',
  extends: BaseCellType,
}
</script>

<style scoped>

</style>
